<app-modal id="site-advert-details-modal" [maskClose]="false">
    <aside class="modal">
      <div class="modal-body">
        <div class="header">
          <p class="title">{{ title }}</p>
          <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
        </div>
        <div class="content">
            <div [innerHTML]="content"></div>
        </div>
      </div>
    </aside>
    <div class="modal-background"></div>
  </app-modal>
